import { render, staticRenderFns } from "./spareShareGoodsDetail.vue?vue&type=template&id=5d7567a2&scoped=true"
import script from "./spareShareGoodsDetail.vue?vue&type=script&lang=js"
export * from "./spareShareGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./spareShareGoodsDetail.vue?vue&type=style&index=0&id=5d7567a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7567a2",
  null
  
)

export default component.exports